import { HttpInterceptorFn } from '@angular/common/http';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req.credentials === 'include'
    ? req
    : req.clone({ withCredentials: false, credentials: 'include' }));
};
